export const breakpointsPixels = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1025,
  xxl: 1200,
};
